import { Paragraph2, UIHeading5 } from '@cian/ui-kit/typography';
import * as React from 'react';

import styles from './AreaPartsTable.css';
import { MoreAreasLink } from './components/MoreAreasLink';
import { formatArea, formatFloor, formatPrice } from './helpers';
import { IAreaPart } from '../../../types/offer';

export const MAX_AREA_PARTS_TO_SHOW = 5;

const AREA_PART_ANCHOR = '#/area-parts';

export interface IAreaPartsTableProps {
  areaParts: IAreaPart[];
  fullUrl: string;
  isRent: boolean;
  /** Подпись для колонки «Тип помещения» (одинакова для всех строк). */
  typeLabel: string;
  onAreaPartClick?: (areaPart: IAreaPart, index: number) => void;
}

export const AreaPartsTableComponent: React.FC<IAreaPartsTableProps> = ({
  areaParts,
  fullUrl,
  isRent,
  typeLabel,
  onAreaPartClick,
}) => {
  if (areaParts.length === 0) {
    return null;
  }

  const visibleParts = areaParts.slice(0, MAX_AREA_PARTS_TO_SHOW);
  const restCount = Math.max(areaParts.length - MAX_AREA_PARTS_TO_SHOW, 0);
  const targetHref = `${fullUrl}${AREA_PART_ANCHOR}`;

  return (
    <div className={styles['root']} data-name="AreaPartsTable">
      {visibleParts.map((part, index) => {
        const handleClick = onAreaPartClick ? () => onAreaPartClick(part, index) : undefined;
        const floorText = formatFloor(part.floorFrom, part.floorTo);
        const areaText = formatArea(part.area);
        const priceText = formatPrice(part.price, isRent);

        return (
          <a
            className={styles['row']}
            key={index}
            data-name="AreaPartsRow"
            href={targetHref}
            target="_blank"
            rel="noreferrer"
            onClick={handleClick}
          >
            <div className={styles['cellFloor']}>
              <UIHeading5 color="text-primary-default">{floorText}</UIHeading5>
            </div>
            <div className={styles['cellType']}>
              <Paragraph2 color="text-primary-default">{typeLabel}</Paragraph2>
            </div>
            <div className={styles['cellArea']}>
              <Paragraph2 color="accent-main-primary">{areaText}</Paragraph2>
            </div>
            <div className={styles['cellPrice']}>
              <Paragraph2 color="text-primary-default">{priceText}</Paragraph2>
            </div>
          </a>
        );
      })}
      {restCount > 0 && (
        <MoreAreasLink
          href={targetHref}
          count={restCount}
          onClick={
            onAreaPartClick
              ? () => onAreaPartClick(areaParts[MAX_AREA_PARTS_TO_SHOW], MAX_AREA_PARTS_TO_SHOW)
              : undefined
          }
        />
      )}
    </div>
  );
};

AreaPartsTableComponent.displayName = 'AreaPartsTable';

export const AreaPartsTable = React.memo(AreaPartsTableComponent);
